import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import userReducer from "./slices/userSlice";
import menuReducer from "./slices/menuSlice";
import trainingReducer from "./slices/trainingSlice";

const appReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  menus: menuReducer,
  training: trainingReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === "RESET_APP") {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
